module.exports = __webpack_public_path__ + "static/media/ed-authorized-partner.964b7d55.png";